import gql from 'graphql-tag';

import { PointOfInterestFragments } from './fragments/PointOfInterestType';

export const getPointOfInterest = gql`
  query GetPointOfInterest($id: Int) {
    entry: pointOfInterest(id: $id) {
      ...PointOfInterestId
      address
      city
      country
      county
      description
      email
      phone
      primaryName
      rampSurface
      rampType
      state
      website
      zipcode
      primaryType
    }
  }
  ${PointOfInterestFragments.id}
`;
